export enum SendingDomainMethod {
    dns = "dns",
    smtp = "smtp",
    gmail = "gmail",
}

export enum SendingDomainStatus {
    pending = "pending",
    verified = "verified",
    failed = "failed",
}

/** Snapshot of a SendGrid whitelabel domain DNS record. DNS method only. */
export interface SendingDomainDnsRecord {
    host: string;
    type: string;
    data: string;
    valid: boolean;
}
